"use strict";

// generated by genversion
module.exports = '20.0.0';